export const Sweden = {
    name: "Sweden",
    image: "/Swden.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose Sweden for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose Sweden for its innovative education system, focus on sustainability, and excellent research opportunities. The country offers high-quality education with a strong emphasis on critical thinking and creativity.",
            "Sweden's progressive society, English-taught programs, and commitment to equality make it an attractive destination for international students seeking quality education and personal development."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Stockholm ranks among the top student cities globally, known for its excellent universities and high quality of life."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "Sweden offers up to 1 year of post-study work opportunities for international graduates."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "Sweden has 8 universities in the QS World University Rankings, with KTH Royal Institute of Technology ranking in the top 100."
        },
        {
            icon: "fas fa-users",
            title: "Innovation hub",
            description: "Sweden's education system emphasizes innovation, sustainability, and practical learning with strong industry connections."
        }
    ],
    keyFacts: [
        { factNumber: "39", factLabel: "Universities and colleges" },
        { factNumber: "40,000", factLabel: "International Students in Sweden in 2024" },
        { factNumber: "Unlimited", factLabel: "Part-time work permit during breaks" },
        { factNumber: "1 Year", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Stockholm",
        poplulation: "10.5 million",
        economicGrowthRate: "2.1%",
        currency: "Swedish Krona (SEK)",
        language: "Swedish (English widely spoken)",
        weather: [
            "Stockholm: 13°C - 22°C",
            "Gothenburg: 12°C - 21°C",
            "Malmö: 13°C - 22°C",
            "Uppsala: 12°C - 21°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, Cambridge)",
        "Motivation letter",
        "Curriculum Vitae",
        "Valid passport copy",
        "Proof of finances (Bank statements)",
        "Health insurance",
        "Portfolio (for design/arts programs)"
    ],
    intake: {
        title: "Swedish universities offer two main intakes:",
        intakes: [
            {
                name: "Autumn Intake",
                month: "Starts in August/September"
            },
            {
                name: "Spring Intake",
                month: "Starts in January/February (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "Bachelor's Degree",
            duration: "3 years"
        },
        {
            name: "Master's Degree",
            duration: "1-2 years"
        },
        {
            name: "PhD",
            duration: "4 years"
        },
        {
            name: "Professional Degree",
            duration: "3-5 years"
        }
    ],
    popularPrograms: {
        title: "Sweden offers high-quality education with focus on innovation and sustainability. Popular programs for international students include:",
        programs: [
            "Engineering",
            "Computer Science",
            "Business Administration",
            "Environmental Science",
            "Design",
            "Medicine",
            "Social Sciences",
            "Renewable Energy",
            "Gaming Technology"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "SEK 80,000 - 120,000",
            bdt: "8,00,000 – 12,00,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "SEK 80,000 - 140,000",
            bdt: "8,00,000 – 14,00,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "SEK 90,000 - 150,000",
            bdt: "9,00,000 – 15,00,000 BDT"
        },
        {
            program: "PhD Programs",
            local: "Free (with stipend)",
            bdt: "Free with monthly stipend"
        }
    ],
    topCities: {
        title: "Sweden offers excellent education in several vibrant cities with high quality of life. Key student cities include:",
        cities: [
            {
                name: "Stockholm",
                description: "Capital city with top universities and vibrant tech scene"
            },
            {
                name: "Gothenburg",
                description: "Second largest city with excellent university and research facilities"
            },
            {
                name: "Malmö",
                description: "Southern city with growing university presence and innovation focus"
            },
            {
                name: "Uppsala",
                description: "Historic university city with focus on research and innovation"
            },
            {
                name: "Linköping",
                description: "University city with strong engineering and technology programs"
            },
            {
                name: "Lund",
                description: "University town with focus on sciences and humanities"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work unlimited hours during breaks and up to 20 hours per week during study periods. Students typically earn SEK 120-200 per hour. The work experience in Sweden's innovative companies can be highly valuable.",
        postStudyWork: "The Residence Permit for Job Seeking allows graduates to stay and work in Sweden for up to 1 year after graduation. This provides an excellent opportunity to gain work experience in Sweden's strong economy and potentially qualify for permanent residency."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in Sweden?",
            answer: "To apply for a student visa, you need an acceptance letter from a Swedish institution, proof of English proficiency, financial capacity (SEK 8,514 per month), health insurance, and a completed visa application form. The application is processed through the Swedish Migration Agency."
        },
        {
            question: "What are the English language requirements for studying in Sweden?",
            answer: "Most Swedish institutions require IELTS (6.0-6.5), TOEFL (80-90), or Cambridge (B2-C1) scores. Some programs may require higher scores, especially for competitive programs."
        },
        {
            question: "Can I work while studying in Sweden?",
            answer: "Yes, international students can work unlimited hours during breaks and up to 20 hours per week during study periods. The Residence Permit for Job Seeking allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in Sweden?",
            answer: "Yes, there are various scholarships offered by the Swedish government, universities, and external organizations. These include the Swedish Institute Scholarships, university-specific scholarships, and EU/EEA mobility programs."
        },
        {
            question: "How much does it cost to study in Sweden from Bangladesh?",
            answer: "Studying in Sweden from Bangladesh costs around SEK 80,000-150,000 for tuition, SEK 8,000-10,000 per month for living expenses, and SEK 2,000-3,000 for health insurance annually. Total annual cost ranges from SEK 180,000-270,000."
        },
        {
            question: "What GPA is required to study in Sweden from Bangladesh?",
            answer: "To study in Sweden from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
